import { inject, Injectable } from '@angular/core';
import {
  ApplicationInsights,
  ITelemetryItem,
  Snippet,
} from '@microsoft/applicationinsights-web';

import { scrubTelemetry } from './telemetry-scrubber';
import { APPINSIGHTS_CONFIG } from './tokens';

/** Cloud role name for the web app, so it appears as a distinct node in the App Insights Application Map. */
export const WEB_CLOUD_ROLE = 'pulse-ui';

/**
 * Service to initialize ApplicationInsights
 */
@Injectable()
export class AppInsightsService {
  /** Instance of ApplicationInsights */
  public instance: ApplicationInsights;

  /**
   * Constructor, initializes ApplicationInsights
   * @param settings
   */
  constructor() {
    let settings = inject<Snippet>(APPINSIGHTS_CONFIG);

    const hasIngestionTarget =
      !!settings?.config &&
      (!!settings.config.connectionString ||
        !!settings.config.instrumentationKey);

    if (!hasIngestionTarget) {
      settings = {
        config: {
          instrumentationKey: '',
          disableAjaxTracking: true,
        },
      };
    }

    this.instance = new ApplicationInsights(settings);

    this.instance.loadAppInsights();

    // Tag every item with the web cloud role so the browser shows up as its own
    // node in the Application Map, linked to the backend services it calls.
    this.instance.addTelemetryInitializer((item: ITelemetryItem) => {
      item.tags = item.tags || [];
      item.tags['ai.cloud.role'] = WEB_CLOUD_ROLE;
    });

    // Scrub PII/secrets (auth headers, token query params) and drop noisy
    // third-party/telemetry-beacon dependencies before anything is sent.
    this.instance.addTelemetryInitializer(scrubTelemetry);
  }
}
